import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import FormSection from '../formSectionNew';
import localization from 'assets/localization/localization';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import { handleValidateObj } from 'constants/objValues/objvalues';
import Regex from 'services/utils/regex/Regex';
import DatePicker from 'components/sales/datePicker/datePicker';
import { handleFormatDate } from 'constants/dateFormat/dateFormat';
import FileUpload from 'components/sales/fileUpload/fileUpload';
import { Button } from 'react-bootstrap';
import ModalPop from 'components/sales/modal/modal';
import TableSection from 'components/sales/tableSection/tableSection';

const Commercial = ({
  data,
  handleValue,
  isApartment = false,
  isSupply = false,
  supplyNameFun = null,
  splNameData,
  edit = 0,
  documentUploadUrl,
  prefilledData,
  is_fastag,
  isRenewal = false,
  setConfirmInvoices,
  confirmInvoices,
  fetchInvoiceDetails,
  getInvoiceData= [],
  setScheduleType = () => {},
}) => {
  const {
    commercialTypes,
    paymentMode,
    solution_type,
    paymentTerms,
    products,
    no_of_slots,
    lead_category,
    paymentDueDays
  } = data;
  const commercialInput = {
    commercialType: '',
    clientShare: '',
    companyShare: '',
    costPerSlot: '',
    totalAmount: '',
    MGSlots: '',
    revenueSlots: '',
    MGPerSlot: '',
    revenueShare: '',
    supplyName: '',
    takeEtaxes: '',
    takePerct: '',
    paymentTermsDesc: '',
    paymentTerms: '',
    latePayCharge:'',
    products: '',
    paymentTerms2: '',
    paymentMode: '',
    solution_type:'',
    solution_type_name:'',
    totalContract: '',
    LockIn: '',
    yearlyInclin: '',
    securityDeposit: '',
    slotsNoFourWheeler: '',
    slotsNoTwoWheeler: '',
    TagsNoPost: '',
    installationAmount: '',
    subAmt: '',
    parkCommission: '',
    slots4MgCar: '',
    slots2MgBike: '',
    slotsRevenue4Car: '',
    slotsRevenue2Bike: '',
    otherDetailsTerms: '',
    valetProduct: '',
    advertisingCommercials: '',
    paymentDueDays: '',
    expectedLive: '',
    commercialPrefilled: { id: null, value: '' },
    payModePrefilled: { id: null, value: '' },
    payDueDaysPrefilled: { id: null, value: '' },
    solutionPrefilled: { id: null, value: '' },
    productPrefilled: { id: null, value: '' },
    paymentTermPrefilled: { id: null, value: '' },
    latePaymentPrefilled: { id: null, value: '' },
    rel_docs: '',
    commission: '',
    builderType:'',
    // fastag_integrable:'',
    schedule_by:'',
    start_date: ''
  };
  const [supplyCost, setSupplyCost] = useState('');
  const [commercialData, setCommercialData] = useState(commercialInput);
  const [isTarget, setIsTarget] = useState('');
  const [totalContractList, setTotalContractList] = useState([]);
  const [errorMsg, setErrorMsg] = useState('');
  const [solutionTypeS, setSolutionTypeS] = useState();
  const [solutionTypePre, setsolutionTypePre] = useState({ id: '', value: '' });

  useEffect(() => {
    if (data) {
      setSupplyCost(data && data.supply_cost_per_slot);
    }
  }, [data]);
  const handleIdvalue = (val) => {
    setIsTarget(val.id);
    setTimeout(() => {
      setCommercialData({
        ...commercialInput,
        commercialType: val.id,
        solution_type: solutionTypeS,
        solutionPrefilled: solutionTypePre,
      });
      
    }, 100);
  };

  useEffect(() => {
    if (
      prefilledData?.commercial !== undefined &&
      prefilledData?.commercial !== null
    ) {
      const {
        commercialName,
        commercial_type_id,
        commercial_description,
        total_mg_amount,
        payment_term,
        payment_term_type,
        payment_mode,
        payment_mode_id,
        solution_type_name,
        solution_type,
        installation_amount,
        subscription_amount,
        contract_length,
        contract_lockin_period,
        product_id,
        late_payment_charge,
        payment_term_desciption,
        payment_due_days,
        payment_due_days_name,
        expected_live_date,
        mdr_percentage,
        builder_type
        // fastag_integrable

      } = prefilledData?.commercial;
      const {
        security_deposit,
        product_details
      } = prefilledData;

      setIsTarget(commercial_type_id);
      setTimeout(() => {
      setCommercialData({
        // ...commercialData,
        commercialType: commercial_type_id,
        commercialPrefilled: { id: commercial_type_id, value: commercialName },
        paymentTermsDesc: commercial_description,
        totalAmount: total_mg_amount,
        paymentMode: payment_mode_id,
        solution_type: solution_type,
        solutionPrefilled: { id: solution_type, value: solution_type_name },
        payModePrefilled: { id: payment_mode_id, value: payment_mode },
        payDueDaysPrefilled: { id: payment_due_days, value: payment_due_days_name },
        totalContract: contract_length.toString(),
        LockIn: contract_lockin_period,
        securityDeposit: (security_deposit != null) ? security_deposit : "0",
        expectedLive: expected_live_date,
        productPrefilled: { id: product_details.id, value: product_details.name },
        paymentTermPrefilled: { id: payment_term_type, value: payment_term },
        latePaymentPrefilled: {
          id: (late_payment_charge ?? "").toString(),
          value: late_payment_charge != null ? late_payment_charge + "%" : "",
        },
        subAmt: subscription_amount,
        paymentDueDays: payment_due_days,
        products: product_details.id,
        paymentTerms: payment_term_type,
        latePayCharge: late_payment_charge,
        commission: mdr_percentage,
        builderType:builder_type
        // fastag_integrable: fastag_integrable,
      });
      setSolutionTypeS(solution_type);
      setsolutionTypePre({ id: solution_type, value: solution_type_name })
      }, 200);
    }
  }, [prefilledData]);

  useEffect(() => {
    if (supplyNameFun !== null) (async () => await supplyNameFun())();
  }, [supplyNameFun]);

  useEffect(() => {
    let count = 60;
    for (let i = 1; i <= count; i++) {
      if (i === 1) {
        totalContractList.push({
          name: `${i} month`,
          id: `${i} month`,
        });
      } else {
        totalContractList.push({
          name: i === 60 ? `${i}+ months` : `${i} months`,
          id: `${i} months`,
        });
      }
    }
    setTotalContractList(totalContractList);
  }, [totalContractList]);
  useEffect(() => {
    if (isTarget === 5) {
      setCommercialData({ ...commercialData, TagsNoPost: '2235' });
    }
  }, [isTarget]);

  useEffect(() => {
    if (isTarget === 3) {
      setCommercialData({
        ...commercialData,
        revenueSlots: `${
          Number(commercialData.totalAmount) - Number(commercialData.MGSlots)
        }`,
        MGPerSlot: `${Number(
          Number(commercialData.totalAmount) / Number(commercialData.MGSlots)
        ).toFixed()}`,
      });
    }
  }, [commercialData.MGSlots, isTarget]);

  useEffect(() => {
    if (isTarget === 2) {
      setCommercialData({
        ...commercialData,
        costPerSlot: `${(
          Number(commercialData.totalAmount) / no_of_slots
        ).toFixed(2)}`,
      });
    }
  }, [commercialData.totalAmount, isTarget]);

  useEffect(() => {
    if (isTarget === 4) {
      setCommercialData({
        ...commercialData,
        // takeEtaxes: `${
        //   Number(commercialData.costPerSlot) - Number(supplyCost)
        // }`,
        takePerct: `${Math.round(
          (Number(commercialData.takeEtaxes) /
            (Number(commercialData.costPerSlot) - Number(supplyCost))) *
            100
        )}`,
      });
    }
  }, [commercialData.takeEtaxes, isTarget]);

  const handleClientShare = (val) => {
    const clientNumber = Number(val);
    if (clientNumber > 100 || clientNumber < 0) {
      return false;
    } else {
      setCommercialData({
        ...commercialData,
        clientShare: val,
        companyShare: clientNumber > 0 ? `${100 - clientNumber}` : '',
      });
    }
  };

  const handleCommercialData = () => {
    if (isSupply === true) {
      const supplyObj = {
        totalContract: commercialData.totalContract,
        LockIn: commercialData.LockIn,
        paymentDueDays: commercialData.paymentDueDays,
        // builder_type:commercialData.builderType,
      };
      if (isTarget === 5 || isTarget === 7 || isTarget === 16) {
        if (lead_category?.id) {
          if (
              lead_category?.id === 9 ||
              lead_category?.id === 10 ||
              lead_category?.id === 11
          ) {
            supplyObj.installationAmount = commercialData.installationAmount;
            supplyObj.subAmt = commercialData.subAmt;
            supplyObj.paymentMode = commercialData.paymentMode;
            if (lead_category?.id === 10) {
              supplyObj.valetProduct = commercialData.valetProduct;
            }
            if (lead_category?.id === 11) {
              supplyObj.advertisingCommercials =
                  commercialData.advertisingCommercials;
            }
          }
        }
      }
      if (isTarget === 15) {
        supplyObj.commission = commercialData.commission;
      }
      if (isRenewal == false) {
        supplyObj.products= commercialData.products;
        supplyObj.expectedLive = commercialData.expectedLive;
        if (commercialData?.solution_type) {
          supplyObj.solution_type = commercialData?.solution_type;
        }else{
          supplyObj.solution_type = '';
        }
      }
      const isNotEmpty = handleValidateObj(supplyObj);
      if (isNotEmpty !== false) {
        supplyObj.paymentTerms = commercialData.paymentTerms;
        supplyObj.builder_type = commercialData.builderType;
        handleValue(commercialData);
      } else {
        handleValue(null);
      }
    } else {
      if (isTarget === 1) {
        const revenueShare = {
          companyShare: commercialData.companyShare,
          costPerSlot: commercialData.costPerSlot,
          clientShare: commercialData.clientShare,
        };
        const isNotEmpty = handleValidateObj({ ...revenueShare });
        if (isNotEmpty !== false) {
          handleValue(commercialData);
        } else {
          handleValue(null);
        }
      }
      if (isTarget === 2) {
        const mgObj = {
          totalAmount: commercialData.totalAmount,
          costPerSlot: commercialData.costPerSlot,
        };
        const isNotEmpty = handleValidateObj({ ...mgObj });
        if (isNotEmpty !== false) {
          handleValue(commercialData);
        } else {
          handleValue(null);
        }
      }
      if (isTarget === 3) {
        const hybridObj = {
          totalAmount: commercialData.totalAmount,
          MGSlots: commercialData.MGSlots,
          revenueSlots: commercialData.revenueSlots,
          clientShare: commercialData.clientShare,
          companyShare: commercialData.companyShare,
          MGPerSlot: commercialData.MGPerSlot,
          revenueShare: commercialData.revenueShare,
        };
        const isNotEmpty = handleValidateObj(hybridObj);
        if (isNotEmpty !== false) {
          handleValue(commercialData);
        } else {
          handleValue(null);
        }
      }
      if (isTarget === 4) {
        const payPerObj = {
          costPerSlot: commercialData.costPerSlot,
          takeEtaxes: commercialData.takeEtaxes,
          takePerct: commercialData.takePerct,
        };
        const isNotEmpty = handleValidateObj({ ...payPerObj });
        if (isNotEmpty !== false) {
          handleValue(commercialData);
        } else {
          handleValue(null);
        }
      }
      if (isTarget === 5 || isTarget === 6 || isTarget === 7 || isTarget === 16) {
        const capex = {
          totalContract: commercialData.totalContract,
          LockIn: commercialData.LockIn,
          paymentDueDays: commercialData.paymentDueDays,
          // builder_type:commercialData.builderType,
        };
        if (isTarget === 5) {
          capex.totalAmount = commercialData.totalAmount;
        }
        if (isTarget === 6 || isTarget === 7 || isTarget === 16) {
          // capex.installationAmount = commercialData.installationAmount;
          capex.subAmt = commercialData.subAmt;
          // capex.yearlyInclin = commercialData.yearlyInclin;
        }
        if (lead_category?.id === 2) {
          capex.supplyName = commercialData?.supplyName;
        }
        if (commercialData?.paymentMode) {
          capex.paymentMode = commercialData?.paymentMode;
        }
        if (isRenewal == false) {
          if (commercialData?.solution_type) {
            capex.expectedLive= commercialData.expectedLive;
            capex.products= commercialData.products;
            capex.solution_type = commercialData?.solution_type;
          } else {
            capex.solution_type = '';
          }
        }
        // if (commercialData?.fastag_integrable) {
        //   capex.fastag_integrable = commercialData?.fastag_integrable;
        // }else{
        //   capex.fastag_integrable = '';
        // }
        // console.log(capex);
        const isNotEmpty = handleValidateObj(capex);
        if (isNotEmpty !== false) {
          console.log("handle",commercialData)
          // commercialData['paymentTermsDesc'] = commercialData.paymentTermsDesc;
          // setCommercialData(commercialData)
          // handleValue(commercialData)
          handleValue({
            ...commercialData,
            paymentTermsDesc: commercialData.paymentTermsDesc,
            builder_type: commercialData.builderType,
          });
        } else {
          handleValue(null);
        }
      }
    }
  };

  useEffect(() => {
    handleCommercialData();
  }, [commercialData]);

  return (
    <Fragment>
      <FormSection title={localization.commercialType}>
        <DropDownInput
          data={commercialTypes}
          label={localization.commercialType}
          required
          isStarRequired={true}
          errorMsg={localization.requiredcommercialType}
          getIdValue={(val) => handleIdvalue(val)}
          value={commercialData.commercialPrefilled.value}
          disabled = {edit == 1 ?true:false}
        />
      </FormSection>

      {/* is supply is available */}
      {/* {isSupply === true && (
        <Fragment>
          <FormSection title={localization.commercialDisc}>

            {lead_category?.id && (
              <Fragment>
                {lead_category?.id === 9 ||
                lead_category?.id === 10 ||
                lead_category?.id === 11 ? (
                  <Fragment>
                    <ConstantInput
                      label={localization.installationAmount}
                      errorMsg={
                        commercialData.installationAmount === ''
                          ? localization.requiredinstallationAmount
                          : localization.numericError
                      }
                      required
                      isStarRequired={true}
                      type="text"
                      regex={Regex.number.test(
                        commercialData.installationAmount
                      )}
                      handleChange={(val) =>
                        setCommercialData({
                          ...commercialData,
                          installationAmount: val,
                        })
                      }
                    />
                    
                  </Fragment>
                ) : null}
              </Fragment>
            )}
          </FormSection>
        </Fragment>
      )} */}
      {/* end of supply is available sec */}
      {isTarget ? (
        <Fragment>
          {isSupply !== true && (
            <Fragment>
              {isTarget === 1 ? (
                <Fragment>
                  <FormSection title={localization.commercialDisc}>
                    <ConstantInput
                      label={localization.clientShare}
                      errorMsg={localization.requiredclientShare}
                      required
                      isStarRequired={true}
                      regex={Regex.toFixed.test(commercialData.clientShare)}
                      type="text"
                      handleChange={(val) => handleClientShare(val)}
                      value={
                        commercialData.clientShare > 100 ||
                        commercialData.clientShare < 0 ||
                        !Number(commercialData.clientShare).toFixed(2)
                          ? ''
                          : commercialData.clientShare
                      }
                    />
                    <ConstantInput
                      label={localization.companyShare}
                      errorMsg={localization.requiredcompanyShare}
                      required
                      isStarRequired={true}
                      type="text"
                      value={commercialData.companyShare}
                      disabled
                    />
                    <ConstantInput
                      label={localization.costPerSlot}
                      regex={Regex.twodecimal.test(commercialData.costPerSlot)}
                      errorMsg={
                        commercialData.costPerSlot
                          ? localization.requiredDecimal
                          : localization.requiredcostPerSlot
                      }
                      className="indianrupee"
                      type="text"
                      isPrefix
                      prefixText={'₹'}
                      required
                      isStarRequired={true}
                      handleChange={(val) =>
                        setCommercialData({
                          ...commercialData,
                          costPerSlot: val,
                        })
                      }
                    />
                  </FormSection>
                </Fragment>
              ) : null}
            </Fragment>
          )}
          {isTarget === 2 ? (
            <Fragment>
              <FormSection title={localization.commercialDisc}>
                <ConstantInput
                  label={localization.totalAmount}
                  errorMsg={
                    commercialData.totalAmount
                      ? localization.requiredDecimal
                      : localization.requiredtotalAmount
                  }
                  required
                  isStarRequired={true}
                  type="text"
                  className="indianrupee"
                  isPrefix
                  prefixText={'₹'}
                  regex={Regex.twodecimal.test(commercialData.totalAmount)}
                  handleChange={(val) =>
                    setCommercialData({ ...commercialData, totalAmount: val })
                  }
                />
                <ConstantInput
                  label={localization.costPerSlot}
                  errorMsg={localization.isRequired}
                  required
                  isStarRequired={true}
                  value={commercialData.costPerSlot}
                  disabled
                />
              </FormSection>
            </Fragment>
          ) : null}
          {isTarget === 3 ? (
            <Fragment>
              <FormSection title={localization.commercialDisc}>
                <ConstantInput
                  label={localization.totalAmount}
                  type="text"
                  className="indianrupee"
                  isPrefix
                  prefixText={'₹'}
                  errorMsg={
                    commercialData.totalAmount
                      ? localization.requiredDecimal
                      : localization.requiredtotalAmount
                  }
                  regex={Regex.twodecimal.test(commercialData.totalAmount)}
                  required
                  isStarRequired={true}
                  handleChange={(val) =>
                    setCommercialData({ ...commercialData, totalAmount: val })
                  }
                />
                <ConstantInput
                  label={localization.MGSlots}
                  type="number"
                  errorMsg={localization.requiredMGSlots}
                  required
                  isStarRequired={true}
                  handleChange={(val) =>
                    setCommercialData({ ...commercialData, MGSlots: val })
                  }
                />
                <ConstantInput
                  label={localization.revenueSlots}
                  type="number"
                  errorMsg={localization.requiredrevenueSlots}
                  required
                  isStarRequired={true}
                  value={commercialData.revenueSlots}
                  disabled
                />
                <ConstantInput
                  label={localization.clientShare}
                  errorMsg={localization.requiredclientShare}
                  required
                  isStarRequired={true}
                  regex={Regex.toFixed.test(commercialData.clientShare)}
                  type="text"
                  handleChange={(val) => handleClientShare(val)}
                  value={
                    commercialData.clientShare > 100 ||
                    commercialData.clientShare < 0 ||
                    !Number(commercialData.clientShare).toFixed(2)
                      ? ''
                      : commercialData.clientShare
                  }
                />
                <ConstantInput
                  label={localization.companyShare}
                  errorMsg={localization.requiredcompanyShare}
                  required
                  isStarRequired={true}
                  value={commercialData.companyShare}
                  disabled
                />
                <ConstantInput
                  label={localization.MGPerSlot}
                  errorMsg={localization.requiredMGPerSlot}
                  required
                  isStarRequired={true}
                  value={
                    Number(commercialData.MGPerSlot) > 0
                      ? commercialData.MGPerSlot
                      : ''
                  }
                  disabled
                />
                <ConstantInput
                  label={localization.revenueShare}
                  errorMsg={localization.requiredrevenueShare}
                  type="number"
                  required
                  isStarRequired={true}
                  handleChange={(val) =>
                    setCommercialData({ ...commercialData, revenueShare: val })
                  }
                />
              </FormSection>
            </Fragment>
          ) : null}
          {(isTarget === 4 || isTarget === 13 || isTarget === 14) ? (
            <Fragment>
              <FormSection title={localization.commercialDisc}>
                <ConstantInput
                  label={localization.costPerSlot}
                  errorMsg={localization.requiredcostPerSlot}
                  required
                  isStarRequired={true}
                  regex={Regex.toFixed.test(commercialData.costPerSlot)}
                  type="number"
                  handleChange={(val) => {
                    if (
                      Number(val) === '' ||
                      Number(val) === 0 ||
                      Number(val) < Number(commercialData.takeEtaxes)
                    ) {
                      setCommercialData({
                        ...commercialData,
                        takeEtaxes: '',
                        takePerct: '',
                      });
                    } else {
                      setCommercialData({
                        ...commercialData,
                        costPerSlot: val,
                      });
                    }
                  }}
                  value={
                    commercialData.costPerSlot > 100 ||
                    commercialData.costPerSlot < 0
                      ? commercialData.costPerSlot
                      : commercialData.costPerSlot
                  }
                  min={0}
                />
                {errorMsg && (
                  <span style={{ color: 'red', fontSize: '11px' }}>
                    {errorMsg}
                  </span>
                )}
                <ConstantInput
                  type="number"
                  value={
                    Number(commercialData.takeEtaxes) > 0 ||
                    Number(commercialData.takeEtaxes) <=
                      Number(commercialData.costPerSlot)
                      ? commercialData.takeEtaxes
                      : ''
                  }
                  handleChange={(val) => {
                    if (
                      Number(val) <= Number(commercialData.costPerSlot) &&
                      Number(val) >= 0
                    ) {
                      setCommercialData({ ...commercialData, takeEtaxes: val });
                      setErrorMsg('');
                    } else {
                      setErrorMsg(
                        `${localization.takeEtaxes} must be smaller or equals to ${localization.costPerSlot} `
                      );
                    }
                    if (val === '') {
                      setErrorMsg('');
                    }
                  }}
                  label={localization.takeEtaxes}
                  // disabled={commercialData.costPerSlot ? false : true}
                  min={0}
                  max={commercialData.costPerSlot}
                  required
                  isStarRequired={true}
                  errorMsg={localization.requiredTakeEtaxes}
                />
                <ConstantInput
                  value={
                    Number(commercialData.takePerct) > 0
                      ? commercialData.takePerct
                      : ''
                  }
                  label={localization.takePerct}
                  disabled
                />
              </FormSection>
            </Fragment>
          ) : null}
          {isTarget === 15 ? (
              <Fragment>
                <FormSection title={localization.commercialDisc}>
                  <ConstantInput
                      label={localization.commission}
                      required
                      type="number"
                      isStarRequired={true}
                      errorMsg={localization.requiredCommission}
                      handleChange={(val) =>
                          setCommercialData({
                            ...commercialData,
                            commission: val,
                          })
                      }
                      // max={3}
                      maxLength={3}
                      value={commercialData.commission}
                  />
                  <DropDownInput
                      data={paymentMode}
                      label={localization.paymentMode}
                      required
                      isStarRequired={true}
                      errorMsg={localization.requiredpaymentMode}
                      getIdValue={(val) =>
                          setCommercialData({
                            ...commercialData,
                            paymentMode: val.id,
                          })
                      }
                      value={commercialData.payModePrefilled.value}
                  />
                  <DropDownInput
                      data={paymentDueDays}
                      label={localization.paymentDueDays}
                      required
                      isStarRequired={true}
                      errorMsg={localization.requiredpaymentDueDays}
                      getIdValue={(val) =>
                          setCommercialData({
                            ...commercialData,
                            paymentDueDays: val.id,
                          })
                      }
                      value={commercialData.payDueDaysPrefilled.value}
                  />
                  <ConstantInput
                      label={localization.totalContract}
                      required
                      isStarRequired={true}
                      errorMsg={localization.requiredtotalContract}
                      handleChange={(val) =>
                          setCommercialData({
                            ...commercialData,
                            totalContract: val,
                          })
                      }
                      disabled = {edit == 1 ?true:false}
                      value={commercialData.totalContract}
                  />
                  <ConstantInput
                      label={localization.LockIn}
                      required
                      isStarRequired={true}
                      errorMsg={localization.requiredLockIn}
                      handleChange={(val) =>
                          setCommercialData({ ...commercialData, LockIn: val })
                      }
                      value={commercialData.LockIn}
                  />
                  {isRenewal == false ? (
                    <>
                    <DropDownInput
                        data={products}
                        label={localization.products}
                        required
                        isStarRequired={true}
                        // errorMsg={localization.requiredpaymentTerms}
                        getIdValue={(val) =>
                            setCommercialData({
                              ...commercialData,
                              products: val.id,
                            })
                        }
                        value={commercialData.productPrefilled.value}
                    />
                    <DropDownInput
                        label={localization.solutionType}
                        data={data.solutionType}
                        required
                        isStarRequired={true}
                        errorMsg={localization.solutionType}
                        getIdValue={(val) =>
                            setCommercialData({
                              ...commercialData,
                              solution_type: val.id,
                            })
                        }
                        disabled = {edit == 1 ?true:false}
                        value={commercialData.solutionPrefilled.value}

                    />
                    </>
                    )
                    : null
                  }
                </FormSection>
              </Fragment>
          ) : null}
          {/* {isSupply !== true && (
            <Fragment> */}
              {isTarget === 5 || isTarget === 6 || isTarget === 7 || isTarget === 16 ? (
                <Fragment>
                  <FormSection title={localization.commercialDisc}>
                    {isTarget === 6 || isTarget === 7 || isTarget === 16 ? (
                      <Fragment>
                        {/* <ConstantInput
                          label={localization.installationAmount}
                          required
                          isStarRequired={true}
                          type="text"
                          className="indianrupee"
                          isPrefix
                          prefixText={'₹'}
                          errorMsg={
                            commercialData.installationAmount
                              ? localization.requiredDecimal
                              : localization.requiredinstallationAmount
                          }
                          regex={Regex.twodecimal.test(
                            commercialData.installationAmount
                          )}
                          handleChange={(val) =>
                            setCommercialData({
                              ...commercialData,
                              installationAmount: val,
                            })
                          }
                        /> */}
                        <DropDownInput
                          data={paymentTerms}
                          label={localization.paymentTerms}
                          required
                          isStarRequired={true}
                          errorMsg={localization.requiredpaymentTerms}
                          getIdValue={(val) =>
                            setCommercialData({
                              ...commercialData,
                              paymentTerms: val.id,
                            })
                          }
                          value={commercialData.paymentTermPrefilled.value}
                        />
                        {parseInt(commercialData?.commercialType) === 16 && (
                        <>
                          <DropDownInput
                             data={[
                               { name: 'Park+ (Pro-rata/Adjusted Pro-rata, etc.)', id: 1 },
                               { name: `Custom (As per Client's start date)`, id: 2 }
                             ]}
                             label={'Invoicing Schedule'}
                             required
                             isStarRequired={true}
                             getIdValue={(val) => {
                               setCommercialData({
                                 ...commercialData,
                                 schedule_by: val.id,
                               });
                               setScheduleType(val.id)
                             }}
                             // value={commercialData.contractTypePrefilled.value}
                           />
                           {commercialData?.schedule_by === 2 && (
                             <DatePicker
                               handleChange={(val) => {
                                 setCommercialData({
                                   ...commercialData,
                                   start_date: val,
                                 });
                               }}
                               label={'Start Date'}
                               minimumDate={new Date()}
                             />
                           )}
                        </>
                        )}
                      <DropDownInput
                         data={[
                          { id: '0', name: '0%' },
                          { id: '9', name: '9%' },
                          { id: '12', name: '12%' },
                          { id: '15', name: '15%' },
                          { id: '18', name: '18%' },
                        ]}
                          label={localization.latePayCharge}
                          isStarRequired={true}
                          required
                          errorMsg={localization.latePayCharge}
                          getIdValue={(val) =>
                            setCommercialData({
                              ...commercialData,
                              latePayCharge: val.id,
                            })
                          }
                          value={commercialData.latePaymentPrefilled.value}
                        />
                        
                         <ConstantInput
                          label={localization.paymentTermsDesc}
                          handleChange={(val) =>
                            setCommercialData({
                              ...commercialData,
                              paymentTermsDesc: val,
                            })
                          }
                          value={commercialData.paymentTermsDesc}
                        />
                        <ConstantInput
                          label={localization.subAmt}
                          required
                          isStarRequired={true}
                          placeholder={`Enter Quarterly or Monthly Amount Without GST`}
                          type="text"
                          className="indianrupee"
                          isPrefix
                          prefixText={'₹'}
                          errorMsg={
                            commercialData.subAmt
                              ? localization.requiredDecimal
                              : localization.requiredsubAmt
                          }
                          regex={Regex.twodecimal.test(commercialData.subAmt)}
                          handleChange={(val) =>
                            setCommercialData({
                              ...commercialData,
                              subAmt: val,
                            })
                          }
                          value={commercialData.subAmt}
                        />
                      </Fragment>
                    ) : null}
                    {isTarget === 5 ? (
                      <Fragment>
                        <ConstantInput
                          label={localization.totalAmount}
                          type="number"
                          className="indianrupee"
                          isPrefix
                          prefixText={'₹'}
                          regex={Regex.twodecimal.test(
                            commercialData.totalAmount
                          )}
                          errorMsg={
                            commercialData.subAmt
                              ? localization.requiredDecimal
                              : localization.requiredtotalAmount
                          }
                          required
                          isStarRequired={true}
                          handleChange={(val) =>
                            setCommercialData({
                              ...commercialData,
                              totalAmount: val,
                            })
                          }
                          value={commercialData.totalAmount}
                        />
                        <ConstantInput
                          label={localization.paymentTermsDesc}
                          handleChange={(val) =>
                            setCommercialData({
                              ...commercialData,
                              paymentTermsDesc: val,
                            })
                          }
                          value={commercialData.paymentTermsDesc}
                        />
                        {/* <DropDownInput
                          data={paymentTerms}
                          label={localization.paymentTerms}
                          required
                          errorMsg={localization.requiredpaymentTerms}
                          getIdValue={(val) =>
                            setCommercialData({
                              ...commercialData,
                              paymentTerms: val.id,
                            })
                          }
                        /> */}
                      </Fragment>
                    ) : null}
                    <DropDownInput
                      data={paymentMode}
                      label={localization.paymentMode}
                      required
                      isStarRequired={true}
                      errorMsg={localization.requiredpaymentMode}
                      getIdValue={(val) =>
                        setCommercialData({
                          ...commercialData,
                          paymentMode: val.id,
                        })
                      }
                      value={commercialData.payModePrefilled.value}
                    />
                    <DropDownInput
                      data={paymentDueDays}
                      label={localization.paymentDueDays}
                      required
                      isStarRequired={true}
                      errorMsg={localization.requiredpaymentDueDays}
                      getIdValue={(val) =>
                        setCommercialData({
                          ...commercialData,
                          paymentDueDays: val.id,
                        })
                      }
                      value={commercialData.payDueDaysPrefilled.value}
                    />
                    {/* <DropDownInput
                      data={totalContractList}
                      label={localization.totalContract}
                      required
                      errorMsg={localization.requiredtotalContract}
                      getIdValue={(val) =>
                        setCommercialData({
                          ...commercialData,
                          totalContract: val.id,
                        })
                      }
                    /> */}
                    <ConstantInput
                      label={localization.totalContract}
                      required
                      isStarRequired={true}
                      errorMsg={localization.requiredtotalContract}
                      handleChange={(val) =>
                        setCommercialData({
                          ...commercialData,
                          totalContract: val,
                        })
                      }
                      disabled = {edit == 1 ?true:false}
                      value={commercialData.totalContract}
                    />
                    {/* <DropDownInput
                      data={totalContractList}
                      label={localization.LockIn}
                      required
                      errorMsg={localization.requiredLockIn}
                      getIdValue={(val) =>
                        setCommercialData({ ...commercialData, LockIn: val.id })
                      }
                    /> */}
                    <ConstantInput
                      label={localization.LockIn}
                      required
                      isStarRequired={true}
                      errorMsg={localization.requiredLockIn}
                      handleChange={(val) =>
                        setCommercialData({ ...commercialData, LockIn: val })
                      }
                      value={commercialData.LockIn}
                    />
                    {commercialData?.paymentTerms !== undefined && commercialData?.paymentTerms !== '' && commercialData?.start_date !== undefined && commercialData?.start_date !== '' && commercialData?.subAmt !== undefined && commercialData?.subAmt !== '' && commercialData?.totalContract !== undefined && commercialData?.totalContract !== ''}
                    {/* <ConstantInput
                      label={localization.yearlyInclin}
                      required
                      isStarRequired={true}
                      type="number"
                      errorMsg={localization.requiredyearlyInclin}
                      handleChange={(val) =>
                        setCommercialData({
                          ...commercialData,
                          yearlyInclin: val,
                        })
                      }
                    /> */}
                    {/* <ConstantInput
                      label={localization.securityDeposit}
                      // required
                      // isStarRequired={true}
                      className="indianrupee"
                      isPrefix
                      prefixText={'₹'}
                      // regex={Regex.twodecimal.test(
                      //   commercialData.securityDeposit
                      // )}
                      // errorMsg={
                      //   commercialData.securityDeposit
                      //     ? localization.requiredDecimal
                      //     : localization.requiredsecurityDeposit
                      // }
                      type="number"
                      handleChange={(val) =>
                        setCommercialData({
                          ...commercialData,
                          securityDeposit: val,
                        })
                      }
                      value={commercialData.securityDeposit}
                    /> */}
                    {/* <ConstantInput
                      handleChange={(val) =>
                        setCommercialData({
                          ...commercialData,
                          slotsNoFourWheeler: val,
                        })
                      }
                      type="number"
                      value={commercialData.slotsNoFourWheeler}
                       regex={Regex.number.test(
                        commercialData.slotsNoFourWheeler
                      )}
                      errorMsg={localization.requiredslotsNoFourWheeler} 
                      label={localization.slotsNoFourWheeler}
                    /> */}
                    {/* <ConstantInput
                      handleChange={(val) =>
                        setCommercialData({
                          ...commercialData,
                          slotsNoTwoWheeler: val,
                        })
                      }
                      label={localization.slotsNoTwoWheeler}
                      type="number"
                      value={commercialData.slotsNoTwoWheeler}
                      
                    /> */}
                    {/* <ConstantInput
                      value={commercialData.TagsNoPost}
                      handleChange={(val) =>
                        setCommercialData({
                          ...commercialData,
                          TagsNoPost: val,
                        })
                      }
                      required
                      isStarRequired={true}
                      type="number"
                      errorMsg={localization.requiredTagsNoPost}
                      label={localization.TagsNoPost}
                    /> */}
                    

                    {isRenewal == false ? (
                      <>
                      <DatePicker
                        label={localization.expectedLive}
                        required={true}
                        handleChange={(val) =>
                          setCommercialData({ ...commercialData, expectedLive: val })
                        }
                        minimumDate={new Date()}
                        value={commercialData.expectedLive}
                      />
                      <DropDownInput
                        data={products}
                        label={localization.products}
                        required
                        isStarRequired={true}
                        // errorMsg={localization.requiredpaymentTerms}
                        getIdValue={(val) =>
                          setCommercialData({
                            ...commercialData,
                            products: val.id,
                          })
                        }
                        value={commercialData.productPrefilled.value}
                      />
                      <DropDownInput
                          label={localization.solutionType}
                          data={data.solutionType}
                          required
                          isStarRequired={true}
                          errorMsg={localization.solutionType}
                          getIdValue={(val) =>
                            setCommercialData({
                              ...commercialData,
                              solution_type: val.id,
                            })
                          }
                          disabled = {edit == 1 ?true:false}
                        value={commercialData.solutionPrefilled.value}

                        />
                      <FileUpload
                        id="revDoc"
                        accept=".pdf,.png,.jpg"
                        documentUploadUrl={documentUploadUrl}
                        onChange={(val) => setCommercialData({
                          ...commercialData,
                          rel_docs: val.toString(),
                        })}
                        // prefilledFilename={agreementData?.pOUpload}
                        multiple={true}
                      >
                      <span className="btn btn-transparent">
                        {localization.uploadRevDoc}
                      </span>
                        </FileUpload>
                      </>
                      )
                      : null
                    }
                    {   data?.lead_data?.lead_type_id==2 &&
                    <DropDownInput
                      data={[
                        { name: 'Builder', id: 'Builder' },
                        { name: 'RWA', id: 'RWA' }
                      ]}
                      label={localization.builderRwa}
                      required
                      isStarRequired={true}
                      getIdValue={(val) =>
                        setCommercialData({
                          ...commercialData,
                          builderType: val.id,
                        })
                      }
                      value={commercialData.builderType??''}
                      errorMsg={localization.builderRwaError}                    />
                    } 
                    {/* {is_fastag ?
                      <DropDownInput
                      data={[
                          { id: 'yes', name: 'Yes' },
                          { id: 'No', name: 'No' },
                        ]}
                        required
                        isStarRequired={true}
                        label={localization.fastag_integrable}
                        errorMsg={localization.fastag_integrable}
                        getIdValue={(val) =>
                          setCommercialData({
                            ...commercialData,
                            fastag_integrable: val.id,
                          })
                        }
                        value={commercialData.fastag_integrable ?commercialData.fastag_integrable:'No' }
                      />
                      :null}   */}

                    {/* {isSupply === false && ( */}

                    {/* )} */}
                    {lead_category?.id === 2 ? (
                      <DropDownInput
                        data={splNameData}
                        label={localization.supplyNamePost}
                        required
                        errorMsg={localization.requiredsupplyNamePost}
                        getIdValue={(val) =>
                          setCommercialData({
                            ...commercialData,
                            supplyName: val.id,
                          })
                        }
                      />
                    ) : null}
                    {isTarget === 15 ? (
                        <ConstantInput
                            label={localization.totalContract}
                            required
                            isStarRequired={true}
                            errorMsg={localization.requiredtotalContract}
                            handleChange={(val) =>
                                setCommercialData({
                                  ...commercialData,
                                  totalContract: val,
                                })
                            }
                            disabled = {edit == 1 ?true:false}
                            value={commercialData.totalContract}
                        />
                    ) : null}
                  </FormSection>
                </Fragment>
                
              ) : null}
            {/* </Fragment>
          )} */}
          
        </Fragment>
      ) : null}
    </Fragment>
  );
};

Commercial.propTypes = {
  data: PropTypes.any,
  handleValue: PropTypes.func,
  isApartment: PropTypes.bool,
};

export default Commercial;
